import React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import useAdminCategories from '../../hooks/useAdminCategories';
import Card from '../../components/ui/Card';
import Spinner from '../../components/ui/Spinner';
import { useToast } from '../../components/ui/Toast';
import CategoryForm from '../../components/admin/CategoryForm';

export default function CategoryEditor() {
  const { id } = useParams();
  const isNew = !id;
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { categories, loading, create, update } = useAdminCategories();

  const category = isNew ? null : categories.find((c) => c._id === id);

  const done = () => {
    addToast('Category saved', { variant: 'success' });
    navigate('/admin/categories');
  };

  if (loading) {
    return <div className="ss-state"><Spinner label="Loading category" size={32} /></div>;
  }

  return (
    <div>
      <p style={{ marginBottom: 'var(--ss-space-3)' }}>
        <Link to="/admin/categories" className="ss-back-link"><ArrowLeft size={16} aria-hidden="true" /> Back to Categories</Link>
      </p>
      <h1>{isNew ? 'New category' : 'Edit category'}</h1>

      <div style={{ marginTop: 'var(--ss-space-5)', maxWidth: '32rem' }}>
        <Card>
          <CategoryForm
            initial={category}
            categories={categories}
            onSubmit={(body) => (isNew ? create(body) : update(id, body))}
            onDone={done}
            onCancel={() => navigate('/admin/categories')}
          />
        </Card>
      </div>
    </div>
  );
}
